import { useEffect } from "react";
import ApplyQuickVisa from "./component/ApplyQuickVisa";
// import PartnerLogos from "./component/PartnerLogos";
import ServicesHero from "./component/ServicesHero";
import VisaServices from "./component/VisaServices";

export default function Services() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"     // smooth scroll to top
        });
    }, []);

    return (

        <>
            <ServicesHero />
            <VisaServices />
            <ApplyQuickVisa />
            {/* <PartnerLogos /> */}
        </>
    )
}